export default __webpack_public_path__ + "static/media/activate-logo.747b040d.png";